<script>
    import {createEventDispatcher} from "svelte";
    const dispatch = createEventDispatcher();

    export let disabled = false

    function chooseIcon(disabled) {
        if (disabled) {
            return "fa-spinner-third fa-spin"
        }
        return "fa-chevron-down"
    }
</script>

<div class="col-12">
    <div class="d-flex justify-content-center">
        <button type="button" class="btn btn-slate-50" on:click={(e) => dispatch('click', e)}>Zobraziť viac <i class="far {chooseIcon(disabled)} ml-3"></i></button>
    </div>
</div>